import React from 'react'
import { gsap, ScrollTrigger } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)

class Feedback extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedFeedback: null
        }

        this.domRef = React.createRef()
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleSubmit(event) {
        if (this.props.submitUri && this.state.selectedFeedback === null) {
            const selectedValue = event.currentTarget.dataset.rating
    
            this.setState({
                selectedFeedback: selectedValue
            })

            const httpRequest = new XMLHttpRequest

            httpRequest.open('POST', this.props.submitUri, true)
            httpRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
            httpRequest.send('curatorialid=' + this.props.curatorialId + '&rating=' + selectedValue)
        } 
    }

    componentDidMount() {
        document.addEventListener('allimagesloaded', () => {
            gsap.from(this.domRef.current.querySelectorAll('button'), {
                opacity: 1,
                stagger: 0.25,
                scrollTrigger: {
                    trigger: this.domRef.current,
                    start: 'center 80%'
                }
            })
        })
    }

    render() {
        return (
            <div className="feedback" ref={this.domRef}>
                {this.props.children}
                <button data-rating="very bad" className={this.state.selectedFeedback == 'very bad' && 'selected'} onClick={this.handleSubmit}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                        <path className="st0" d="M11,2.2c4.8,0,8.8,3.9,8.8,8.8s-3.9,8.8-8.8,8.8s-8.8-4-8.8-8.8S6.2,2.2,11,2.2 M11,0C4.9,0,0,4.9,0,11 s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0L11,0z"/>
                        <line className="st1" x1="9" y1="6.4" x2="9" y2="8.7"/>
                        <line className="st1" x1="13" y1="6.4" x2="13" y2="8.7"/>
                        <path className="st2" d="M6.2,16.1c0-2.7,2.2-4.8,4.8-4.8s4.8,2.2,4.8,4.8"/>
                    </svg>
                </button>
                <button data-rating="bad" className={this.state.selectedFeedback == 'bad' && 'selected'} onClick={this.handleSubmit}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                        <path className="st0" d="M11,2.2c4.8,0,8.8,3.9,8.8,8.8s-3.9,8.8-8.8,8.8s-8.8-4-8.8-8.8S6.2,2.2,11,2.2 M11,0C4.9,0,0,4.9,0,11 s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0L11,0z"/>
                        <path className="st1" d="M5.5,14.4L5.5,14.4c3.4-2,7.7-2,11.1,0l0,0"/>
                        <line className="st1" x1="9" y1="6.4" x2="9" y2="8.7"/>
                        <line className="st1" x1="13" y1="6.4" x2="13" y2="8.7"/>
                    </svg>
                </button>
                <button data-rating="good" className={this.state.selectedFeedback == 'good' && 'selected'} onClick={this.handleSubmit}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                        <path className="st0" d="M11,2.2c4.8,0,8.8,3.9,8.8,8.8s-3.9,8.8-8.8,8.8s-8.8-4-8.8-8.8S6.2,2.2,11,2.2 M11,0C4.9,0,0,4.9,0,11 s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0L11,0z"/>
                        <path className="st1" d="M16.5,13L16.5,13c-3.4,2-7.7,2-11.1,0l0,0"/>
                        <line className="st1" x1="9" y1="6.4" x2="9" y2="8.7"/>
                        <line className="st1" x1="13" y1="6.4" x2="13" y2="8.7"/>
                    </svg>
                </button>
                <button data-rating="very good" className={this.state.selectedFeedback == 'very good' && 'selected'} onClick={this.handleSubmit}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                        <path className="st0" d="M11,2.2c4.8,0,8.8,3.9,8.8,8.8s-3.9,8.8-8.8,8.8s-8.8-4-8.8-8.8S6.2,2.2,11,2.2 M11,0C4.9,0,0,4.9,0,11 s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0L11,0z"/>
                        <line className="st1" x1="9" y1="6.4" x2="9" y2="8.7"/>
                        <line className="st1" x1="13" y1="6.4" x2="13" y2="8.7"/>
                        <path className="st2" d="M15.8,11.3c0,2.7-2.2,4.8-4.8,4.8S6.2,14,6.2,11.3"/>
                    </svg>
                </button>
            </div>
        )
    }
}

export default Feedback